import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import type { ReactNode } from 'react'

import { queryClient } from './react-query-config'

interface QueryProviderProps {
  children: ReactNode
  enableDevtools?: boolean
}

export const QueryProvider = ({ children, enableDevtools = false }: QueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {enableDevtools && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  )
}
